module.exports = __webpack_public_path__ + "img/initial-balanceTxt.878cf090.png";